export class HeaderType {
    header: string;
    field: string;
    headerA: string;
    fieldA: string;
    headerP: string;
    fieldP: string;
    width: string;
}